import { ClipboardText, FileArrowDown, Plant, TreeEvergreen } from '@phosphor-icons/react'
import { Subtext, Text } from '../../../../Components/Screen/Text/Body'
import { Subheading } from '../../../../Components/Screen/Text/Heading'

const InfoRow = ({ label, value }) => {
  if (value === undefined || value === null || value === '') return null
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-1 py-2 border-b border-cinzaescuro/40 last:border-0">
      <Text className="text-laranja shrink-0 sm:w-52">{label}:</Text>
      <Text>{String(value)}</Text>
    </div>
  )
}

const FileList = ({ files }) => {
  if (!files || files.length === 0) return null
  return (
    <ul className="flex flex-col gap-2 mt-2">
      {files.map((doc) => (
        <li
          key={doc?.url}
          className="flex items-center justify-between gap-3 px-4 py-3 border border-cinzaescuro rounded-lg"
        >
          <Text className="truncate">{doc?.name}</Text>
          <a
            href={doc?.url}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 text-verdeClaro hover:underline shrink-0"
          >
            <FileArrowDown size={18} />
            <Subtext className="text-verdeClaro">Ver documento</Subtext>
          </a>
        </li>
      ))}
    </ul>
  )
}

const certificationLabels = {
  'N/A': 'N/A',
  Conditional: 'Condicional',
  Wood: 'Madeira',
  Bronze: 'Bronze',
  Silver: 'Prata',
  Gold: 'Ouro',
  Platinum: 'Platina',
}

export const Documents = ({ art }) => {
  const crop = art?.cropDetails
  const defo = art?.deflorestation

  const hasCrop = crop && Object.keys(crop).length > 0
  const hasDefo = defo && Object.keys(defo).length > 0

  if (!hasCrop && !hasDefo) {
    return (
      <div className="flex flex-col w-full md:px-20 py-6 gap-4">
        <div className="flex items-center gap-3">
          <ClipboardText size={48} className="bg-cinzaescuro text-branco rounded-full p-2 shrink-0" />
          <Subheading>Avaliação de Cultivo</Subheading>
        </div>
        <Subtext className="text-cinza">Nenhum dado disponível.</Subtext>
      </div>
    )
  }

  return (
    <div className="flex flex-col w-full md:px-20 py-6 gap-8">
      {hasCrop && (
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-3">
            <Plant size={48} className="bg-cinzaescuro text-verdeClaro rounded-full p-2 shrink-0" />
            <Subheading>Detalhes do Cultivo</Subheading>
          </div>

          <div className="flex flex-col px-2">
            <InfoRow label="Tipo de Cultivo" value={crop?.cropType?.name || crop?.cropType} />
            <InfoRow label="Tipo de Semente" value={crop?.seedType} />
            <InfoRow label="Ano da Colheita" value={crop?.harvestYear} />
            <InfoRow label="Estimativa de Rendimento" value={crop?.yieldEstimation ? `${crop.yieldEstimation} Tons` : undefined} />
            <InfoRow label="Número de Lotes" value={crop?.nParcels} />
            <InfoRow
              label="IDs dos Lotes"
              value={Array.isArray(crop?.parcelId) && crop.parcelId.length > 0 ? crop.parcelId.join(', ') : crop?.parcelId}
            />
            <InfoRow
              label="Geolocalização"
              value={
                crop?.parcelGeolocation?.latitude && crop?.parcelGeolocation?.longitude
                  ? `${crop.parcelGeolocation.latitude}, ${crop.parcelGeolocation.longitude}`
                  : undefined
              }
            />
          </div>

          {crop?.file?.length > 0 && (
            <div className="flex flex-col gap-2">
              <Text className="text-cinza">Documentos de Cultivo</Text>
              <FileList files={crop.file} />
            </div>
          )}
        </div>
      )}

      {hasDefo && (
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-3">
            <TreeEvergreen size={48} className="bg-cinzaescuro text-laranja rounded-full p-2 shrink-0" />
            <Subheading>Degradação Florestal</Subheading>
          </div>

          <div className="flex flex-col px-2">
            <InfoRow label="CAR" value={defo?.carNumber} />
            <InfoRow label="PRA" value={defo?.pra} />
            <InfoRow label="Conformidade com CAR" value={defo?.carCompliance ? 'Sim' : defo?.carCompliance === false ? 'Não' : undefined} />
            <InfoRow label="Área Produtiva" value={defo?.permanentPreservedArea ? `${defo.permanentPreservedArea} ha` : undefined} />
            <InfoRow label="Reserva Legal" value={defo?.legalReserve ? `${defo.legalReserve}%` : undefined} />
            <InfoRow
              label="Tipo de Certificação"
              value={defo?.certificationType ? (certificationLabels[defo.certificationType] || defo.certificationType) : undefined}
            />
            <InfoRow label="Estimativa de Rendimento" value={defo?.yieldEstimation ? `${defo.yieldEstimation} Tons` : undefined} />
            <InfoRow label="Auditoria por" value={defo?.auditBy} />
          </div>

          {defo?.file?.length > 0 && (
            <div className="flex flex-col gap-2">
              <Text className="text-cinza">Documentos de Desmatamento</Text>
              <FileList files={defo.file} />
            </div>
          )}
        </div>
      )}
    </div>
  )
}
